import { render, staticRenderFns } from "./policy-layout.component.vue?vue&type=template&id=5e46a9a4&scoped=true"
import script from "./policy-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./policy-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./policy-layout.component.vue?vue&type=style&index=0&id=5e46a9a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e46a9a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e46a9a4')) {
      api.createRecord('5e46a9a4', component.options)
    } else {
      api.reload('5e46a9a4', component.options)
    }
    module.hot.accept("./policy-layout.component.vue?vue&type=template&id=5e46a9a4&scoped=true", function () {
      api.rerender('5e46a9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/policy-layout/policy-layout.component.vue"
export default component.exports